import React from 'react';
import { useGuestAuth } from '@/hooks/useGuestAuth';
import { GuestLogin } from '@/components/guest/GuestLogin';
import { GuestDashboard } from '@/components/guest/GuestDashboard';
import { LoadingSpinner } from '@/components/ui/loading-spinner';

const GuestApp = () => {
  const { guestSession, loading } = useGuestAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  return guestSession ? <GuestDashboard /> : <GuestLogin />;
};

export default GuestApp;